import { createApp } from "vue";
import { createPinia } from 'pinia';
import App from "./App.vue";
import router from "./router";
import * as Sentry from "@sentry/vue";

import 'bootstrap/dist/js/bootstrap.js';
import '@/bootstrapSettings.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@vueform/multiselect/themes/default.scss'

const app = createApp(App);
const pinia = createPinia();

// Conditionally add the Yandex Metrica script based on the environment variable
if (process.env.VUE_APP_YANDEX_METRICA === 'true') {
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(97436805, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    });

    // Add the noscript part to ensure tracking for users with JavaScript disabled
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/97436805" style="position:absolute; left:-9999px;" alt="" /></div>';
    document.body.appendChild(noscript);
}

if (process.env.SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: `https://${process.env.SENTRY_DSN}@sentry.mars-saz.ru/3`,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
            })
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

app.use(pinia);

app.use(router).mount("#app");

